// Generated by CoffeeScript 2.7.0
var Calculation;

import Base from './base.js';

export default Calculation = class Calculation extends Base {
  constructor(attrs = {}, logic_settings = {}, fieldable) {
    var base;
    super(attrs, logic_settings, fieldable);
    if (this.visibility === 'public_visibility') {
      this.visibility = 'protected_visibility';
    }
    if ((base = this.data).execed_js == null) {
      base.execed_js = '';
    }
  }

  resolveTypedAttributes(attributes, _specified_attributes, _from_field_type) {
    attributes.data.execed_js = '';
    return attributes;
  }

};
